import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableEditVodOutputs from './tableEditVodOutputs';

export default {
  title: 'Vod Backend Outputs',
  attributeName: 'vodOutputs',
  fields: [
    {
      attributeName: 'vodOutputs',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableEditVodOutputs,
    },
  ],
};
